import React from 'react';
import { T } from 'shared/helper/translate';
var PlanStatusBadge = function PlanStatusBadge(_ref) {
  var status = _ref.status;
  return /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("span", {
    className: "badge badge-rubriq-".concat(status, " text-capitalize")
  }, /*#__PURE__*/React.createElement(T, {
    source: status === 'cancelled' ? 'Active' : status
  })));
};
export default PlanStatusBadge;